import { render, staticRenderFns } from "./WCompanyAbout.vue?vue&type=template&id=a32aa970&"
import script from "./WCompanyAbout.vue?vue&type=script&lang=ts&"
export * from "./WCompanyAbout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports